module.exports = __webpack_public_path__ + "img/baleLogo.458231c9.png";